
import { showSuccessNotification } from '@shazambanking/sdk/services/notifications';
// iziToast.css - safe to prune in webpack tree shaking
import 'izitoast/dist/css/iziToast.css'; 
import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';


import { EMPTY_STRING } from './Constants';
import { EnrollmentFormWrapper } from './EnrollmentFormWrapper';
import Header from './Header';

interface IState {
  companyPhone: string;
  email: string;
  firstName: string;
  lastName: string;
  requiresApproval: boolean;
  userName: string;
}

class UserConfirmation extends React.Component<RouteComponentProps<any>, IState> {
  constructor(props: any) {
    super(props);

    if (this.props.location.state !== undefined) {
      this.state = {
        companyPhone: this.props.location.state.companyPhone,
        email: this.props.location.state.email,
        firstName: this.props.location.state.firstName,
        lastName: this.props.location.state.lastName,
        requiresApproval: this.props.location.state.requiresApproval,
        userName: this.props.location.state.userName
      };
    } else {
      this.state = {
        companyPhone: EMPTY_STRING,
        email: EMPTY_STRING,
        firstName: EMPTY_STRING,
        lastName: EMPTY_STRING,
        requiresApproval: false,
        userName: EMPTY_STRING
      };
    }
  }

  public render() {
    const { companyPhone, email, firstName, lastName, requiresApproval, userName } = this.state;

    if (
      email === EMPTY_STRING ||
      firstName === EMPTY_STRING ||
      lastName === EMPTY_STRING ||
      userName === EMPTY_STRING
    ) {
      this.props.history.push('/login');
    }
    else {
      showSuccessNotification(requiresApproval ? 'User Enrollment Initiated' : 'User Enrollment Success');
    }

    if(requiresApproval) {
      return (
        <EnrollmentFormWrapper>
          <Header />
          <div className="enrollment-panel">
            <p className="enrollment-desc">
              Welcome <b>{firstName} {lastName}</b>. Please note your username: <b>{userName}</b>.
            </p>
            <p className="enrollment-desc">
              Thank you for requesting access to your account.
              To complete your enrollment, please contact your financial institution {companyPhone}
            </p>
          </div>
        </EnrollmentFormWrapper>
      );
    } else {
      return (
        <EnrollmentFormWrapper>
          <Header />
          <div className="enrollment-panel">
            <p className="enrollment-desc">
              Welcome <b>{firstName} {lastName}</b>, you have successfully enrolled in Online Banking!
              Please note your username: <b>{userName}</b>. Click the button below to send an email with
              your first-time password to <b>{email}</b>.
            </p>
            <div className="detail-btn-group">
              <button
                type="button"
                className="btn btn-default btn-submit primary">
                <Link
                  className="link"
                  to={'/changePassword'}>
                  Setup Your Password
                </Link>
              </button>
            </div>
          </div>
        </EnrollmentFormWrapper>
      );
    }
  }
}

export default UserConfirmation;



// WEBPACK FOOTER //
// ./src/UserConfirmation.tsx